import React from 'react';
import './AppLogo.scss';

interface Props extends React.HTMLProps<HTMLDivElement> {
    inverted?: boolean;
}

const AppLogo: React.FC<Props> = ({inverted}: Props) => {
    const imagem = inverted ? 'app-logo-principal.webp' : 'app-logo-inverso.webp';
    return (
        <img src={`${process.env.PUBLIC_URL}/assets/images/${imagem}`} alt={'Digital Sim'} className={'AppLogo'}
             data-testid="AppLogo"/>
    );
};

export default AppLogo;

